import { render, staticRenderFns } from "./Registrazione.vue?vue&type=template&id=483a67cd&scoped=true"
import script from "./Registrazione.vue?vue&type=script&lang=js"
export * from "./Registrazione.vue?vue&type=script&lang=js"
import style0 from "./Registrazione.vue?vue&type=style&index=0&id=483a67cd&prod&scoped=true&lang=css"
import style1 from "./Registrazione.vue?vue&type=style&index=1&id=483a67cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a67cd",
  null
  
)

export default component.exports